export default "__VITE_ASSET__CO34DU09__"